export const competenceTemplate = [
    {
        questionDimension: 'Competence',
        type: 'Matrix',
        questionLabel: 'Competence',
        options: [
            {
                label: "Strongly disagree",
                value: "1"
            },
            {
                label: "Somewhat disagree",
                value: "2"
            },
            {
                label: "Neither agree nor disagree",
                value: "3"
            },
            {
                label: "Somewhat agree",
                value: "4"
            },
            {
                label: "Strongly agree",
                value: "5"
            }
        ],
        question: '',
        matrixQuestions: [{
            text: 'I feel like I can accomplish anything at work.', value: '', isSelected: true
        },
        {
            text: 'My work challenges me in a good way.', value: '', isSelected: true

        },
        {
            text: 'I feel accomplished after a day of work.', value: '', isSelected: true

        },
        {
            text: 'I am good at what I do at work.', value: '', isSelected: false

        }]
    }
]

